import React, { Component, ReactNode } from 'react';
import NotFoundBg from '@/assets/not-found.png';
import JenLogo from '@/assets/jen-logo-orange.png';

interface ErrorBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // todo: monitor to server
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return <DefaultError />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

const DefaultError = () => {
  return (
    <div className="p-[16px] w-full h-full bg-[#161616] text-white ">
      <div
        style={{
          background: `url(${JenLogo}) 0% 0% / cover no-repeat`,
        }}
        className="w-[69px] h-[48px]"
      ></div>
      <div className="mt-[62px] m-auto text-[18px]">
        <div className="text-center">Oops! Something went wrong.</div>
      </div>
      <div
        className="w-[90vw] m-auto mt-[100px]"
        style={{
          background: `url(${NotFoundBg}) 0% 0% / cover no-repeat`,
        }}
      >
        <div className="w-full" style={{ paddingTop: '43%' }}></div>
      </div>
    </div>
  );
};
